import update from 'immutability-helper';
import RecipientManagerConstants from './RecipientManagerConstants';

const initialState = {
  activeTab: RecipientManagerConstants.RECIPIENT_MANAGER_ADD_RECIPIENTS_TAB_SHOW,
};

const RecipientManagerReducer = (state, action) => {
  if (typeof state === 'undefined') {
    return initialState;
  }

  switch (action.type) {
    case RecipientManagerConstants.RECIPIENT_MANAGER_ADD_RECIPIENTS_TAB_SHOW: {
      return update(state, {
        activeTab: { $set: RecipientManagerConstants.RECIPIENT_MANAGER_ADD_RECIPIENTS_TAB_SHOW },
      });
    }
    case RecipientManagerConstants.RECIPIENT_MANAGER_PUBLIC_LINK_TAB_SHOW: {
      return update(state, {
        activeTab: { $set: RecipientManagerConstants.RECIPIENT_MANAGER_PUBLIC_LINK_TAB_SHOW },
      });
    }
    default:
      return state;
  }
};

export default RecipientManagerReducer;



// WEBPACK FOOTER //
// ./src-react/SelfServePostBuilderSidePanel/RecipientManager/RecipientManagerReducer.jsx